import { Modal } from "bootstrap";
import $ from "jquery";
import { Echangeur, EchangeurException } from "./Echangeur";
import MiniFormulaire from "./MiniFormulaire";
import Store    from "./Store";
import hash     from "./hash";

import { setLangue, setSessionDroits } from "./formulaire/composant/b2bLangue";
import Contexte from "./global";

// Variable globale
const defaultHash = "#universe";
const formulaire = {}; // liste des formulaires existants

let lanceCgu = false;

Echangeur.prototype.onErrorAsync_401 = async function (param) {
  try { 
    if (uiContexte && uiContexte.data && uiContexte.data.session !== undefined && uiContexte.data.session !== false ) {
        var PAGE = new MiniFormulaire(); //
        PAGE.initialise("#authentification");
        PAGE.fillImport(formulaire.loginModal);
        PAGE.data = {};
        const data = await lanceMf(PAGE);
        $("#authentification").empty();
        return data;
    } else { 
      throw new EchangeurException(0, "Chargelogin", null, true);
    }
  } catch (e) {
    throw e;
  }
};

 



async function onHashChange() {
  //
  
  let CTX = Store.get("CTX");
  //
  if ( CTX.disableOnHashChange ) return;
 
  const array = hash.toArray();
  const hash0 = array.length ? array[0] : {};

  if (!hash0.hash) {
      window.location.hash = defaultHash;
      return;
  } else if (hash0.hash == "logout") { 
      CTX.session = null;
      CTX.disableOnHashChange = true;
      //
      await Echangeur.logout();
      window.location.hash = "";
      await demarrageClientSession();

      return;
  }
  
  // Redirige vers la page par défault si l'univer n'existe pas
  if (("#" + hash0.hash) !== defaultHash && CTX.hasUniver( hash0.par.u) ) {  
      window.location.hash = defaultHash;
      return;
  }
  var last = array[array.length - 1];
  var index = array.length;
  if (index > 1)  hash.ecrans[index - 1].sauve(); 
  $("#hash0").hide();
  //
  for (let i = 0; i < hash.ecrans.length; i++) {
      if (i <= index) hash.ecrans[i].hide(); // Masque tous les écrans précédent  l'écran en cours
      if (i > index)  hash.ecrans[i].purge(); // Purge  tous les écrans après l'écrans au dessus
  }
 
  await CTX.update()

  var ecran = hash.ecrans[index];
  //
  if ( ecran &&  ecran.mf &&  ecran.mf.cacheHash &&  ecran.mf.cacheHash == last.hash && ecran.mf.reprise ) {
      const x = new Echangeur();
      x.hash = last.par;
      ecran.mf.reprise(ecran, x);
  } else {
      if (!formulaire[last.hash]) throw "Formulaire inexistant : " + last.hash;
      //
      // console.log("MiniFormulaire"+ecran.id)
      ecran.mf = new MiniFormulaire();
      ecran.mf.initialise("#" + ecran.id);
      ecran.mf.fillImport(formulaire[last.hash]);
      const x = new Echangeur("getForm_" + last.hash);
      x.hash = last.par;
      await ecran.mf.demarre(last.par, hash.fin, x);
      ecran.mf.cacheHash = last.hash;
  }
  
   hash.refreshAriane();
}

document.addEventListener("DOMContentLoaded", function (event) {
  demarrageClient();
});

async function demarrageClient() {
  // a remove wait

  let CTX = Store.get("CTX"); 
  if(!CTX) {
    CTX = new Contexte();
    Store.set("CTX",CTX);
    Store.set('getURUL',CTX.getURUL)
  }
  
  await setLangue("en");

  const addToFormulaire = function (u) {
    for (var i in u.default) formulaire[i] = u.default[i];
  };
  //
  addToFormulaire(await import("./formulaire/universe"));
  addToFormulaire(await import("./formulaire/universeEdit"));
  addToFormulaire(await import("./formulaire/home"));
  addToFormulaire(await import("./formulaire/signin"));
  addToFormulaire(await import("./formulaire/sessionExpired"));
  addToFormulaire(await import("./formulaire/myAccount"));
  //
  addToFormulaire(await import("./formulaire/orderList"));
  addToFormulaire(await import("./formulaire/orderHistory"));

  addToFormulaire(await import("./formulaire/orderValidateHist"));

  addToFormulaire(await import("./formulaire/orderValidate"));
  addToFormulaire(await import("./formulaire/orderVerifie"));
  addToFormulaire(await import("./formulaire/orderManager"));
  addToFormulaire(await import("./formulaire/orderMassImport"));
  //
  addToFormulaire(await import("./formulaire/env"));
  //
  addToFormulaire(await import("./formulaire/brandname/brandnameList"));
  addToFormulaire(await import("./formulaire/brandname/brandname"));

  //
  addToFormulaire(await import("./formulaire/edi/edi"));
  addToFormulaire(await import("./formulaire/edi/ediSinglePage"));
  addToFormulaire(await import("./formulaire/edi/poSinglePage"));
  addToFormulaire(await import("./formulaire/edi/orderMassImportEdi"));


  addToFormulaire(await import("./formulaire/orderVerifiePo")); 


  // addToFormulaire(await import("./formulaire/edi/poChangeSenderSinglePage"));
  // addToFormulaire(await import("./formulaire/edi/poChangeSenderSinglePage"));

  //
  addToFormulaire(await import("./formulaire/season/seasonList"));
  addToFormulaire(await import("./formulaire/season/season"));
  addToFormulaire(await import("./formulaire/season/seasonExclusEdit"));
  addToFormulaire(await import("./formulaire/season/seasonExclusCustomers"));
  //
  addToFormulaire(await import("./formulaire/linelist"));
  addToFormulaire(await import("./formulaire/linelistEdit"));
  addToFormulaire(await import("./formulaire/customEdit"));
  addToFormulaire(await import("./formulaire/customBrandname"));
  //
  addToFormulaire(await import("./formulaire/productSaisie"));
  //
  addToFormulaire(await import("./formulaire/user/users"));
  addToFormulaire(await import("./formulaire/user/userDetail"));
  //
  addToFormulaire(await import("./formulaire/group/groups"));
  addToFormulaire(await import("./formulaire/group/groupDetail"));
  //
  addToFormulaire(await import("./formulaire/savethe/savethe"));
  addToFormulaire(await import("./formulaire/savethe/savetheDetail"));
  //
  addToFormulaire(await import("./formulaire/importproduct"));
  //
  addToFormulaire(await import("./formulaire/stock/importstock"));
  addToFormulaire(await import("./formulaire/stock/importstockdetail"));
  //
  addToFormulaire(await import("./formulaire/archives/archives"));
  //
  addToFormulaire(await import("./formulaire/sidebar"));
  addToFormulaire(await import("./formulaire/notifications"));
  //
  addToFormulaire(await import("./formulaire/codification/codification"));
  //
  addToFormulaire(await import("./formulaire/pagebuilder"));
  addToFormulaire(await import("./formulaire/tasks"));

  
  addToFormulaire(await import("./formulaire/cgvModal")); 
  addToFormulaire(await import("./formulaire/cgvModalOrderValidate")); 
  //
  //
  await demarrageClientSession();
}

async function demarrageClientSession() { 
  
  let CTX = Store.get("CTX");
  while (CTX.session == null) {
    try {
      CTX.session = await Echangeur.restnomodal("sessionInit"); //on verifie si on est authentifié
      CTX.session.isPretenom = CTX.session.realuser !== CTX.session.username;
    } catch (e) {
       CTX.session = null;
    }
    if (!CTX.session) {
      lanceCgu = true;
      await demarrageClientSignin();
    }
  } 
  
  //
  setSessionDroits(CTX.session.droits); 
  await demarrageClientSuite(); 
  //
}

function demarrageClientSignin() {
  // Lancement du formulaire de login
  return new Promise(function (resolve, reject) {
    var mf = new MiniFormulaire("login");
    mf.initialise("#hash0");
    mf.fillImport(formulaire.signin);
    //
    mf.demarre({}, function () {
      // fonction fin du miniformulaire  
      resolve();
    });
    
  });
}

window.onError401 = function () {
  return new Promise(function (resolve, reject) {
    const element = document.getElementById("sessionexpiredmodal");
    //
    const miniFormulaire = new MiniFormulaire();
    miniFormulaire.initialise(element);
    miniFormulaire.fillImport(formulaire.sessionExpired);
    //
    let CTX = Store.get("CTX");
    miniFormulaire.demarre({ session: CTX.session }, function () {
      // fonction fin du miniformulaire 
      modal.hide();
      resolve();
    });
    //
    const options = { backdrop: "static" };
    const modal = new Modal(element, options);
    //
    modal.show();
    element.addEventListener("hidden.bs.modal", function (event) {
      //console.log("modal hide");
    });
  });
};



/*

  permet d'afficher un logo en cas de probleme.

*/

window.fetchResponse = function (fr) {
  $(".___error").hide()


  if(fr.status == 401){

  }
  if(fr.status != 200){
      // probleme lan ??
      $(".___error").show()
  }
  


};


// Ici, on est authentifié
async function demarrageClientSuite() {

  let CTX = Store.get("CTX"); 
  
  // a remove wait
  $("#topbar").empty();
  $("#offcanvasCart").empty();
  $("#sidebarOffcanvasActivity").empty();
  $("#sidebar").empty();
  // 
  {
    CTX.sidebar = new MiniFormulaire("sidebar");
    CTX.sidebar.initialise("#sidebar");
    CTX.sidebar.fillImport(formulaire.sidebar);
    CTX.sidebar.CTX = CTX;
    await CTX.sidebar.demarre(CTX.session);
  } 
  {
    CTX.notifications = new MiniFormulaire("notifications");
    CTX.notifications.initialise("#sidebarOffcanvasActivity");
    CTX.notifications.fillImport(formulaire.notifications);
    CTX.notifications.CTX = CTX;
    await CTX.notifications.demarre(CTX.session);
  }
 
  CTX.updatepanier =  async function () { 
    this.orderManager = null;
    {
      this.orderManager = new MiniFormulaire("topbar");
      this.orderManager.initialise("#topbar");
      this.orderManager.fillImport(formulaire.orderManager);
      await this.orderManager.demarre();
    }
  }

  CTX.updateTaskFormulaire = async function () {
    this.tasks = null;
    {
      this.tasks = new MiniFormulaire("tasks");
      this.tasks.initialise("#asidetasksbadgealert");
      this.tasks.fillImport(formulaire.tasks);
      this.tasks.CTX = this;
      await this.tasks.demarre(this.session);
    }
  }
  //  
  CTX.cgvModal = async function () { 
    this.cgvModal = null;
    {
      this.cgvModal = new MiniFormulaire("cgvModal");
      this.cgvModal.initialise("#b2bcontmodal");
      this.cgvModal.fillImport(formulaire.cgvModal);
      this.cgvModal.CTX = this;
      await this.cgvModal.demarre(this.session);
    }
  }
  //
  
  //if(!CTX.session.acceptedCGU)  {
    if(lanceCgu){
      lanceCgu = false;
    // console.log(CTX.session)
     CTX.cgvModal() 
  } 
  //
  if (!CTX.orderManager) {
    // await CTX.updatepanier();
    // await CTX.updateTaskFormulaire();
    await CTX.update();
  }
  //
  CTX.cliqueSurUniver = false; 
  CTX.disableOnHashChange = false;
  CTX.CGUAccepted = false;
  // 
  window.onhashchange = onHashChange;
  onHashChange();
}

/*
 * Lance le formulaire de login pour modal & 1er page
 */
const lanceMf = function (mf) {
  return new Promise(function (resolv, reject) {
    mf.fin = function (data) {
      resolv(data);
    };
    mf.annuler = function (data) {
      reject();
    };
    mf.demarre();
  });
};

export default {};


  // {
  //   CTX.tasks = new MiniFormulaire("tasks");
  //   CTX.tasks.initialise("#asidetasksbadgealert");
  //   CTX.tasks.fillImport(formulaire.tasks);
  //   CTX.tasks.CTX = CTX;
  //   await CTX.tasks.demarre(CTX.session);
  // }


  // async function updatepanier(CTX) {
  //   CTX.orderManager = null;
  //   {
  //     CTX.orderManager = new MiniFormulaire("topbar");
  //     CTX.orderManager.initialise("#topbar");
  //     CTX.orderManager.fillImport(formulaire.orderManager);
  //     await CTX.orderManager.demarre();
  //   }
  // }